import { LEGAL_MATERIALITIES, PublishLegalVersionSchema } from '@aysar/contracts';
import { z } from 'zod';

import { type FieldDef } from '@/shared/components/dynamic-form/types/dynamic-form.types';

import { type Translate } from './legal-document-form.config';

/**
 * What the dialog edits. The contract's `effectiveAt` is optional, but a
 * `datetime` control holds `null` when empty — so the form accepts `null` and
 * the submit turns it back into absence ("now").
 */
export const PublishFormSchema = PublishLegalVersionSchema.extend({
  effectiveAt: z.iso.datetime().nullable().optional(),
});

export type PublishFormValues = z.infer<typeof PublishFormSchema>;

/**
 * The choice with no default (N16): each option says, in plain words, what it
 * does to every member — because that, not the label, is the decision.
 */
export function buildPublishFields(t: Translate): FieldDef[] {
  return [
    {
      name: 'materiality',
      kind: 'radio-group',
      label: t('publish.form.materiality'),
      isRequired: true,
      colSpan: 'full',
      options: LEGAL_MATERIALITIES.map((materiality) => ({
        value: materiality,
        label: t(`materiality.${materiality}`),
        description: t(`publish.form.${materiality}Hint`),
      })),
    },
    {
      name: 'effectiveAt',
      kind: 'datetime',
      label: t('publish.form.effectiveAt'),
      description: t('publish.form.effectiveAtHint'),
      colSpan: 'full',
    },
  ];
}
